import { render, staticRenderFns } from "./workpackage-selector.vue?vue&type=template&id=6711c169&scoped=true"
import script from "./workpackage-selector.vue?vue&type=script&lang=js"
export * from "./workpackage-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6711c169",
  null
  
)

export default component.exports